<div class="substitutes-filter pb-2" *appUserPermissions="[UserRoles.APP.ADMIN, UserRoles.APP.SUPER_USER]">
  <span class="relative">
    <span
      [matMenuTriggerFor]="filterMenu"
      #trigger="matMenuTrigger"
      role="button"
      data-test-id="input_select_substituteType"
      (menuOpened)="cd.markForCheck()"
      (menuClosed)="cd.markForCheck()"
    >
      <span class="pr-q fs-lg">
        <ng-container *ngIf="scope === 'my'">{{ 'module.substitute.text.my-substitutes' | translate }}</ng-container>
        <ng-container *ngIf="scope === 'all'">{{ 'module.substitute.text.all-substitutes' | translate }}</ng-container>
      </span>
      <span class="icon icon-arrow-down absolute fs-lg" [ngClass]="{'rotate-180': trigger.menuOpen}"></span>
    </span>
  </span>
  <mat-menu #filterMenu="matMenu" xPosition="after" [backdropClass]="'substitute-menu'">
    <button mat-menu-item data-test-id="button_substitutes_my" (click)="scope = 'my'">
      <span>{{ 'module.substitute.text.my-substitutes' | translate }}</span>
    </button>
    <button mat-menu-item data-test-id="button_substitutes_all" (click)="scope = 'all'">
      <span>{{ 'module.substitute.text.all-substitutes' | translate }}</span>
    </button>
  </mat-menu>
</div>

<ng-container *ngIf="{substitutes: substitutes$ | async} as dataSubscr">
  <app-substitute-list [testId]="[testId, 'list'].join('_')" [substitutes]="dataSubscr.substitutes" [scope]="scope">
    <ng-container *ngIf="loading$ | async">
      <div class="loading d-flex jc-center">
        <div class="d-flex ai-center jc-center">
          <span class="spinner spinner-bounce-middle mr-1"></span>
          <span class="regular pl-h">{{ 'common.statuses.loading' | translate }}</span>
        </div>
      </div>
    </ng-container>
  </app-substitute-list>
</ng-container>
